import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../core/api/client';

export const useCategories = () => {
    const queryClient = useQueryClient();

    const fetchCategories = async () => {
        const { data } = await api.get<any>('/api/admin/categories');
        return data || [];
    };

    const fetchPublicCategories = async () => {
        const { data } = await api.get<any>('/api/categories');
        return data || [];
    };

    const createCategory = async (categoryData: any) => {
        const { data } = await api.post('/api/admin/categories', categoryData);
        return data.data;
    };

    const updateCategory = async ({ id, ...updateData }: { id: string;[key: string]: any }) => {
        const { data } = await api.put(`/api/admin/categories/${id}`, updateData);
        return data.data;
    };

    const deleteCategory = async (id: string) => {
        const { data } = await api.delete(`/api/admin/categories/${id}`);
        return data;
    };

    const {
        data: categories,
        isLoading,
        error
    } = useQuery({
        queryKey: ['categories'],
        queryFn: fetchCategories
    });

    const createMutation = useMutation({
        mutationFn: createCategory,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['categories'] });
            queryClient.invalidateQueries({ queryKey: ['public-categories'] });
        }
    });

    const updateMutation = useMutation({
        mutationFn: updateCategory,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['categories'] });
            queryClient.invalidateQueries({ queryKey: ['public-categories'] });
        }
    });

    const deleteMutation = useMutation({
        mutationFn: deleteCategory,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['categories'] });
            queryClient.invalidateQueries({ queryKey: ['public-categories'] });
        }
    });

    return {
        categories: categories || [], // Default to empty array
        isLoading,
        error,
        createCategory: createMutation.mutateAsync,
        updateCategory: updateMutation.mutateAsync,
        deleteCategory: deleteMutation.mutateAsync,
        isCreating: createMutation.isPending,
        isUpdating: updateMutation.isPending,
        isDeleting: deleteMutation.isPending
    };
};

// Separate hook for public consumption if needed specifically
export const usePublicCategories = () => {
    return useQuery({
        queryKey: ['public-categories'],
        queryFn: async () => {
            const { data } = await api.get<any>('/api/categories');
            return data || [];
        }
    });
};
